import { render, staticRenderFns } from "./branchesEdit.vue?vue&type=template&id=393be2c4&scoped=true&"
import script from "./branchesEdit.vue?vue&type=script&lang=js&"
export * from "./branchesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393be2c4",
  null
  
)

export default component.exports